import api from '../apis/api';
import { isAuthFailed } from '../services/auth';
import getMessageFromApiError from '../util/getMessageFromApiError';
import { setErrorMessage } from './errorMessage';

export const recordLogin = async () => {
  try {
    const res = await api.patch('/customer', { last_login: Date.now() });
    return res.data;
  } catch (error) {
    const message = getMessageFromApiError(error);
    setErrorMessage(message);
    throw new Error(`API Error - ${message}`);
  }
};

export const fetchUser = async () => {
  if (isAuthFailed()) {
    return null;
  }
  try {
    const res = await api.get('/customer');
    return res.data;
  } catch (error) {
    if (error?.isAuthError || isAuthFailed()) {
      return null;
    }

    console.log('User fetch error:', error);
    const message = getMessageFromApiError(error);
    if (message && message !== 'The incoming token has expired') {
      console.log('Non-auth error:', message);
    }
    throw error;
  }
};

export const createUser = async () => {
  // all the user details come from the token
  try {
    const res = await api.post('/customer', {
      signup_brand: import.meta.env.VITE_ORG_NAME,
    });
    return res.data;
  } catch (error) {
    const message = getMessageFromApiError(error);
    setErrorMessage(message);
    throw error;
  }
};

export const updateUser = async (values) => {
  try {
    const res = await api.patch('/customer', values);
    return res.data;
  } catch (error) {
    const message = getMessageFromApiError(error);
    setErrorMessage(message);
    throw new Error(`API Error - ${message}`);
  }
};

export const deleteUser = async () => {
  try {
    const res = await api.delete('/customer');
    return res.data;
  } catch (error) {
    const message = getMessageFromApiError(error);
    setErrorMessage(message);
    throw new Error(`API Error - ${message}`);
  }
};

export const createApiKey = async () => {
  try {
    const res = await api.post('/customer/key', {}, { responseType: 'blob' });
    const url = window.URL.createObjectURL(res.data);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `credentials.json`);
    // 3. Append to html page
    document.body.appendChild(link);
    // 4. Force download
    link.click();
    // 5. Clean up and remove the link
    link.parentNode.removeChild(link);
    // Return updated user - caller should fetch user after this
    return null;
  } catch (error) {
    const message = getMessageFromApiError(error);
    setErrorMessage(message);
    throw new Error(`API Error - ${message}`);
  }
};

export const removeApiKey = async (id) => {
  try {
    await api.delete(`/customer/key/${id}`);
    // Return updated user - caller should fetch user after this
    return null;
  } catch (error) {
    const message = getMessageFromApiError(error);
    setErrorMessage(message);
    throw new Error(`API Error - ${message}`);
  }
};

export const createBillingLinkRequest = async (email) => {
  try {
    await api.post('/customer/link/request', {
      requested_billing_email: email,
    });
    // Return updated user - caller should fetch user after this
    return null;
  } catch (error) {
    const message = getMessageFromApiError(error);
    setErrorMessage(message);
    throw new Error(`API Error - ${message}`);
  }
};

export const cancelBillingLinkRequest = async () => {
  try {
    await api.delete('/customer/link/request');
    // Return updated user - caller should fetch user after this
    return null;
  } catch (error) {
    const message = getMessageFromApiError(error);
    setErrorMessage(message);
    throw new Error(`API Error - ${message}`);
  }
};

export const cancelBillingLink = async () => {
  try {
    await api.delete('/customer/link');
    // Return updated user - caller should fetch user after this
    return null;
  } catch (error) {
    const message = getMessageFromApiError(error);
    setErrorMessage(message);
    throw new Error(`API Error - ${message}`);
  }
};

export const approveBillingLink = async (customer_uuid) => {
  try {
    await api.post(`/customer/link`, { customer_uuid });
    // Return updated user - caller should fetch user after this
    return null;
  } catch (error) {
    const message = getMessageFromApiError(error);
    setErrorMessage(message);
    throw new Error(`API Error - ${message}`);
  }
};

export const rejectBillingLinkRequest = async (customer_uuid) => {
  try {
    await api.delete(`/customer/link/request/${customer_uuid}`);
    // Return updated user - caller should fetch user after this
    return null;
  } catch (error) {
    const message = getMessageFromApiError(error);
    setErrorMessage(message);
    throw new Error(`API Error - ${message}`);
  }
};

export const removeBillingLink = async (customer_uuid) => {
  try {
    await api.delete(`/customer/link/${customer_uuid}`);
    // Return updated user - caller should fetch user after this
    return null;
  } catch (error) {
    const message = getMessageFromApiError(error);
    setErrorMessage(message);
    throw new Error(`API Error - ${message}`);
  }
};
